import { render, staticRenderFns } from "./GridRestaurantHome.vue?vue&type=template&id=96c07906&scoped=true&"
import script from "./GridRestaurantHome.vue?vue&type=script&lang=js&"
export * from "./GridRestaurantHome.vue?vue&type=script&lang=js&"
import style0 from "./GridRestaurantHome.vue?vue&type=style&index=0&id=96c07906&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c07906",
  null
  
)

export default component.exports